import { CLEAR_ALERT_BOX, SET_ALERT_BOX } from '@App/constantes'
import { Alert } from '@App/reducers/types'

interface SetAlertAction {
  type: typeof SET_ALERT_BOX
  payload: Alert
}

interface ClearAlertAction {
  type: typeof CLEAR_ALERT_BOX
  payload: any
}

export type AlertActionTypes = SetAlertAction | ClearAlertAction

export function setAlertBox(alert: Alert): AlertActionTypes {
  return {
    type: SET_ALERT_BOX,
    payload: alert,
  }
}

export function clearAlertBox(): AlertActionTypes {
  return {
    type: CLEAR_ALERT_BOX,
    payload: {},
  }
}
